import { memo, useContext } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { data1 } from "../../App";
import Sticky from "../sticky-footer/Sticky";

function Footer() {
  const setServiceseta = useContext(data1);
  return (
    <>
      <section className="footblack">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div>
                <div className="footlogobox">
                  <LazyLoadImage className="footlogo" src="../photo/logo.jpg" />
                </div>
                <p style={{ color: "white", paddingTop: "10px" }}>
                  Viksha Health Care offers advanced orthopedic services with
                  expert care for bones, joints, and injuries. Our team focuses
                  on accurate diagnosis, personalized treatment, and
                  rehabilitation to restore mobility and improve quality of
                  life.
                </p>
                <div className="footadd">
                  <div className="footicon">
                    <LazyLoadImage
                      className="iconfoot"
                      src="../photo/pin.png"
                    />
                  </div>
                  <h6>
                    95,15th Main, 17th Cross Rd, 5th Phase, J. P. Nagar,
                    Bengaluru, Karnataka 560078
                  </h6>
                </div>
                <div className="footadd footmar">
                  <div className="footicon">
                    <LazyLoadImage
                      className="iconfoot"
                      src="../photo/phone.png"
                    />
                  </div>
                  <h6>
                    <a
                      style={{ textDecoration: "none", color: "white" }}
                      href="tel:+918431069548"
                    >
                      84310 69548
                    </a>{" "}
                  </h6>
                </div>
                <div className="footadd footmar">
                  <div className="footicon">
                    <LazyLoadImage
                      className="iconfoot"
                      src="../photo/phone.png"
                    />
                  </div>
                  <h6>
                    <a
                      style={{ textDecoration: "none", color: "white" }}
                      href="tel:+919583476804"
                    >
                      9583476804
                    </a>{" "}
                  </h6>
                </div>
                <div className="footadd footmar">
                  <div className="footicon">
                    <LazyLoadImage
                      className="iconfoot"
                      src="../photo/search-mail.png"
                    />
                  </div>
                  <h6>docck2018@gmail.com</h6>
                </div>
                <div className="footiconbox">
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    className="footicon softiconmar"
                  >
                    <LazyLoadImage
                      className="iconfoot"
                      src="../photo/facebook.png"
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="footicon softiconmar"
                  >
                    <LazyLoadImage
                      className="iconfoot"
                      src="../photo/instagram (1).png"
                    />
                  </a>
                  <a
                    href="https://www.google.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Google"
                    className="footicon softiconmar"
                  >
                    <LazyLoadImage
                      className="iconfoot"
                      src="../photo/google (1).png"
                    />
                  </a>
                  <a
                    href="https://x.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="X (Twitter)"
                    className="footicon softiconmar"
                  >
                    <LazyLoadImage
                      className="iconfoot"
                      src="../photo/twitter (3).png"
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div>
                <div className="footertittle">
                  <h5>Orthopedics Services</h5>
                </div>

                <Link
                  onClick={() => {
                    setServiceseta("Orthopaedic Clinic");
                  }}
                  to="/service/orthopaedicClinic"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Orthopaedic Clinic</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Orthopaedic Consultation");
                  }}
                  to="/service/orthopaedicConsultation"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Orthopaedic Consultation</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta(
                      "Evaluation and Diagnosis of Bone, Joint, Muscle and Ligament Problems",
                    );
                  }}
                  to="/service/orthopaedicEvaluation"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Evaluation & Diagnosis</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Personalized Treatment Planning");
                  }}
                  to="/service/treatmentPlanning"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Personalized Treatment Planning</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta(
                      "Bone Fracture Treatment Surgical And Conservative Treatment",
                    );
                  }}
                  to="/service/boneFracture"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Bone Fracture Treatment</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Fracture & Trauma Care");
                  }}
                  to="/service/fractureTraumaCare"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Fracture & Trauma Care</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta(
                      "Plaster Casting, Splinting and Follow-up Care",
                    );
                  }}
                  to="/service/plasterCasting"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Plaster Casting & Splinting</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Sports Injury Management");
                  }}
                  to="/service/sportsInjury"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Sports Injury Management</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Ligament Injuries (ACL, PCL, Meniscus)");
                  }}
                  to="/service/ligamentInjuries"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Ligament Injuries</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Tendon Injuries and Muscle Strains");
                  }}
                  to="/service/tendonMuscleInjuries"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Tendon & Muscle Injuries</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Return-to-Sport Rehabilitation");
                  }}
                  to="/service/returnToSport"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Return-to-Sport Rehab</h6>
                </Link>
                <Link
                  onClick={() => {
                    setServiceseta("Arthroscopy (Keyhole Surgery)");
                  }}
                  to="/service/arthroscopy"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Arthroscopy (Keyhole Surgery)</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta(
                      "Arthroscopic Acl Andmenicus Repair Reconstruction",
                    );
                  }}
                  to="/service/arthroscopicAcl"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>ACL & Meniscus Surgery</h6>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div>
                <div className="footertittle">
                  <h5 style={{ visibility: "hidden" }}>Orthopedics Services</h5>
                </div>

                <Link
                  onClick={() => {
                    setServiceseta("Arthroscopic Shoulder Surgeries");
                  }}
                  to="/service/arthroscopicShoulder"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Arthroscopic Shoulder Surgery</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Joint Replacement Services");
                  }}
                  to="/service/jointReplacement"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Joint Replacement Services</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta(
                      "Knee And Hip Replacement Surgery Primary And Revision",
                    );
                  }}
                  to="/service/kneeAndHip"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Knee & Hip Replacement</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Back & Spine Care");
                  }}
                  to="/service/backSpineCare"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Back & Spine Care</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Paediatric Orthopaedics");
                  }}
                  to="/service/paediatricOrthopaedics"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Paediatric Orthopaedics</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta(
                      "Congenital Deformities & Growth Related Issues",
                    );
                  }}
                  to="/service/congenitalOrtho"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Congenital & Growth Issues</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Pain Management Procedures");
                  }}
                  to="/service/painManagement"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Pain Management</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Joint Injections");
                  }}
                  to="/service/jointInjections"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Joint Injections</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("PRP and Non-Surgical Pain Relief Options");
                  }}
                  to="/service/prpTherapy"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>PRP Therapy</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Rehabilitation & Physiotherapy Guidance");
                  }}
                  to="/service/rehabilitation"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Rehabilitation & Physiotherapy</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Post-Operative Rehabilitation Protocols");
                  }}
                  to="/service/postOpRehab"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Post-Operative Rehab</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Strengthening and Mobility Exercises");
                  }}
                  to="/service/mobilityExercises"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Strength & Mobility Exercises</h6>
                </Link>

                <Link
                  onClick={() => {
                    setServiceseta("Diabetic Wound Dressing And Management");
                  }}
                  to="/service/diabeticWound"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Diabetic Wound Care</h6>
                </Link>
              </div>
            </div>

            {/* <div className="col-lg-3 col-md-6">
                    <div>
                        <div className="footertittle">
                            <h5>OBG Services</h5>
                        </div>
                        <Link onClick={()=>{
                                        setServiceseta("General Obstetrics")
                                      }} to="/service/generalObstetrics" className="footinfo">
                            <div className="arrowicon">
                                <LazyLoadImage className="arrowbar" src="../photo/arrow-right.png"/>
                            </div>
                            <h6>General Obstetrics</h6>
                        </Link>
                        <Link onClick={()=>{
                                        setServiceseta("High Risk Obstetric Cases")
                                      }} to="/service/highRiskObstetric" className="footinfo">
                            <div className="arrowicon">
                                <LazyLoadImage className="arrowbar" src="../photo/arrow-right.png"/>
                            </div>
                            <h6>High Risk Obstetric Cases</h6>
                        </Link>
                        <Link onClick={()=>{
                                        setServiceseta("PIH(Pregnancy Induced Hypertension)")
                                      }} to="/service/pih" className="footinfo">
                            <div className="arrowicon">
                                <LazyLoadImage className="arrowbar" src="../photo/arrow-right.png"/>
                            </div>
                            <h6>PIH(Pregnancy Induced Hypertension)</h6>
                        </Link>
                        <Link onClick={()=>{
                                        setServiceseta("APH(Antepartum Haemorrhage)")
                                      }} to="/service/aph" className="footinfo">
                            <div className="arrowicon">
                                <LazyLoadImage className="arrowbar" src="../photo/arrow-right.png"/>
                            </div>
                            <h6>APH(Antepartum Haemorrhage)</h6>
                        </Link>
                        <Link onClick={()=>{
                                        setServiceseta("PPH(Postpartum Haemorrhage)")
                                      }} to="/service/pph" className="footinfo">
                            <div className="arrowicon">
                                <LazyLoadImage className="arrowbar" src="../photo/arrow-right.png"/>
                            </div>
                            <h6>PPH(Postpartum Haemorrhage)</h6>
                        </Link>
                        <Link onClick={()=>{
                                        setServiceseta("Ectopic Pregnancy")
                                      }} to="/service/ectopicPregnancy" className="footinfo">
                            <div className="arrowicon">
                                <LazyLoadImage className="arrowbar" src="../photo/arrow-right.png"/>
                            </div>
                            <h6>Ectopic Pregnancy</h6>
                        </Link>
                        <Link onClick={()=>{
                                        setServiceseta("Pre-Eclampsia")
                                      }} to="/service/preEclampsia" className="footinfo">
                            <div className="arrowicon">
                                <LazyLoadImage className="arrowbar" src="../photo/arrow-right.png"/>
                            </div>
                            <h6>Pre-Eclampsia</h6>
                        </Link>
                        <Link onClick={()=>{
                                        setServiceseta("Inevitable Abortion")
                                      }} to="/service/inevitableAbortion" className="footinfo">
                            <div className="arrowicon">
                                <LazyLoadImage className="arrowbar" src="../photo/arrow-right.png"/>
                            </div>
                            <h6>Inevitable Abortion</h6>
                        </Link>
                    </div>
                </div> */}

            <div className="col-lg-3 col-md-6">
              <div>
                <div className="footertittle">
                  <h5>Services in clinic</h5>
                </div>
                <Link
                  onClick={() => {
                    setServiceseta("High intensity digital xray");
                  }}
                  to="/service/highintensity"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>High intensity digital xray</h6>
                </Link>
                <Link
                  onClick={() => {
                    setServiceseta("Laboratory blood collection centre");
                  }}
                  to="/service/laboratory"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Laboratory blood collection centre</h6>
                </Link>
                <Link
                  onClick={() => {
                    setServiceseta("Wound dressing");
                  }}
                  to="/service/wounddressing"
                  className="footinfo"
                >
                  <div className="arrowicon">
                    <LazyLoadImage
                      className="arrowbar"
                      src="../photo/arrow-right.png"
                    />
                  </div>
                  <h6>Wound dressing</h6>
                </Link>
                <div className="mailsender">
                  <input className="mailinpu"></input>
                  <div className="sendboxem">
                    <LazyLoadImage
                      className="sendemail"
                      src="../photo/search-mail.png"
                    ></LazyLoadImage>
                  </div>
                </div>
                <div className="footmapdi">
                  <iframe
                    className="footmap"
                    title="Viksha Health Care Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.0609402557434!2d77.58933237473317!3d12.903802987405383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1516bf217723%3A0xa1830d0adcd10419!2s95%2C%2015th%20Main%20Rd%2C%205th%20Phase%2C%20J%20P%20Nagar%20Phase%205%2C%20J.%20P.%20Nagar%2C%20Bengaluru%2C%20Karnataka%20560078!5e0!3m2!1skn!2sin!4v1684741264703!5m2!1skn!2sin"
                    allowFullScreen
                    loading="lazy"
                    style={{ height: "300px" }}
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          <div className="row rowcop">
            <div className="rowcopin">
              <div className="copy">
                <div>
                  <LazyLoadImage
                    className="copyri"
                    src="../photo/copyright.png"
                  />
                </div>
                <h6> Viksha Health Care, Design By </h6>
              </div>
              <div>
                <a
                  className="acopy"
                  href="https://appaddindia.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6> Appaddindia.com</h6>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Sticky />
    </>
  );
}
export default memo(Footer);
